import { render, staticRenderFns } from "./UnitSettings.vue?vue&type=template&id=34a882d2&scoped=true"
import script from "./UnitSettings.vue?vue&type=script&lang=ts"
export * from "./UnitSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a882d2",
  null
  
)

export default component.exports